import React, { Suspense, memo, useCallback, useState } from 'react';
import { withRouter } from 'react-router-dom';

import Navbar from 'components/Navbar';
import Sidebar from 'components/Sidebar';
import { StepperProvider } from 'common/Stepper';

import { HeaderContext } from './HeaderContext';
import './Layout.scss';

const Layout = ({ children }) => {
  const [urlComponentMapping, setUrlComponentMapping] = useState({});
  const registerUrlComponent = useCallback(
    (url, component) => {
      setUrlComponentMapping({ ...urlComponentMapping, [url]: component });
    },
    [urlComponentMapping]
  );
  const getUrlComponent = useCallback(
    (url) => {
      const found = Object.keys(urlComponentMapping).find((prefix) => url.startsWith(prefix));
      return found && urlComponentMapping[found];
    },
    [urlComponentMapping]
  );
  const context = { registerUrlComponent, getUrlComponent };

  return (
    <HeaderContext.Provider value={context}>
      <div id="root-header" />
      <div id="root-content">
        <div className="layout">
          <Sidebar />

          <StepperProvider>
            <section className="content-wrapper">
              <Navbar />

              <main id="root-main" className="layout__main">
                <Suspense fallback="loading...">{children}</Suspense>
              </main>
            </section>
          </StepperProvider>
        </div>
      </div>
      <div id="root-bottom" />
    </HeaderContext.Provider>
  );
};

export default memo(withRouter(Layout));
